import { LMS_TEACHER_HOMEBASE_FEATURE_FLAG } from "../../shared/featureFlags";
import { useFeatureFlag } from "../lib/FeatureFlags";

export function useLmsTeacherHomebase() {
  return useFeatureFlag(LMS_TEACHER_HOMEBASE_FEATURE_FLAG);
}
